import { Paragraph, Show, tokens } from '@welbe/web-design-system';
import { Status } from 'App/Components/Status/Status';
import { ReactComponent as Heart } from 'App/assets/img/heart.svg';
import { DefaultActivity } from '../../MoreInfo';
import { examHeaders } from '../../MoreInfo.constants';
import { DefaultContainer } from '../../MoreInfo.styles';
import { DownloadOrdersButton } from '../DownloadOrdersButton/DownloadOrdersButton';
import { TableData, TableHead, TableRow } from '../TableElements/TableElements';
import { ServiceRequestsContainer } from './Exams.styles';

const getAmount = (externalOrders: any[] = []) => {
	if (!externalOrders.length) {
		return {
			finished: false,
			label: '0 de 0',
		};
	}

	const amount = externalOrders.length;
	const amountFinished =
		externalOrders.filter((item) => item.status === 'finished')?.length || 0;

	return {
		finished: amount === amountFinished,
		label: `${amountFinished} de ${amount}`,
	};
};

export const Exams = ({ rows }: DefaultActivity) => {
	if (!rows?.length) return null;

	return (
		<DefaultContainer>
			<Paragraph fontWeight="500" color={tokens.color_primary}>
				Estudios
			</Paragraph>
			<table className="population-see-more-table">
				<TableRow>
					{examHeaders.map((header) => (
						<TableHead key={header.id} id={header.id} width={header.width}>
							{header.label}
						</TableHead>
					))}
				</TableRow>
				{rows.map((row) => (
					<TableRow key={row.id}>
						<TableData>
							<Paragraph
								fontWeight="500"
								width="265px"
								title={row.name}
								elipsis
							>
								{row.name}
							</Paragraph>
						</TableData>
						<TableData>
							<Status status={row.status} />
						</TableData>
						<TableData>
							<DownloadOrdersButton
								id={row.appointmentId}
								name={row.appointmentId}
							/>
						</TableData>
						<TableData>
							<Show
								when={Boolean(row.externalOrders.length)}
								fallback={<Paragraph fontWeight="600">-</Paragraph>}
							>
								<ServiceRequestsContainer>
									<Heart />
									<Paragraph color={tokens.color_primary} fontWeight="500">
										{getAmount(row.externalOrders).label}
									</Paragraph>
								</ServiceRequestsContainer>
							</Show>
						</TableData>
					</TableRow>
				))}
			</table>
		</DefaultContainer>
	);
};
